import { DataBean } from "../../DataBean";


export class CustomProcessType extends DataBean {
    
    


    public async getCustomProcessTypeCatalogByProcessType(processType:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getCustomProcessTypeCatalogByProcessType_Number", [processType]);
    }


}